import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import MotionLazyContainer from './components/MotionLazyContainer';
import NotistackProvider from './components/NotistackProvider';
import { AuthProvider } from './contexts/AuthContext';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider>
      <NotistackProvider>
        <AuthProvider>
          <MotionLazyContainer>
            <ScrollToTop />
            <Router />
          </MotionLazyContainer>
        </AuthProvider>
      </NotistackProvider>
    </ThemeProvider>
  );
}
